import React, { FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Tih.module.css";

const IMG_KICK_LOGO = "assets/kickstarter_logo_green.png"
const IMG_BG_01 = "assets/background_01.png";
const IMG_BG_02 = "assets/background_02.png";
const IMG_BG_03 = "assets/background_03.png";
const IMG_BG_04 = "assets/background_04.png";
const IMG_BG_05 = "assets/background_05.png";
const Logo_IMG = [
    { name: "steam",    href: "https://store.steampowered.com/app/3823170/TIH" },
    { name: "discord",  href: "#" },
    { name: "tiktok",   href: "https://www.tiktok.com/@tih.avatar" },
    { name: "x",        href: "https://x.com/TIHavatar" },
    { name: "youtube",  href: "https://www.youtube.com/@TIHavatar" },
    { name: "instagram",href: "https://www.instagram.com/tih.avatar" },
    { name: "linkedin", href: "https://www.linkedin.com/company/vdigm" },
];

const copy = {
  en: {
    page1_title: "The Next-Gen 3D AI Avatars and Motion Tracking Service",
    page1_title_2: "",
    cta_back_now: "BACK NOW",

    page2_title: "Full Body & Face Camera Based Motion Tracking",
    page2_sub: "Don’t ruin yourself with unnecessary equipment and just turn on your camera !",

    page3_title: "Experience your 3D world",
    page3_line1:
      "Generate your own avatar from just a single photo or create it from scratch",
    page3_line2:
      "",
    page3_line3:"Get an AI NPC to assist you on your channel or even get an AI Avatar Bestfriend",
    page3_line4:"",

    page4_title: "Choose from Many Accessories and Stages",

    bottom_cta_label: "BACK NOW",
  },
  ko: {
    page1_title: "차세대 3D AI 아바타 및",
    page1_title_2: "모션 트래킹 서비스",
    cta_back_now: "지금 후원하기",

    page2_title: "전신 및 얼굴 카메라 기반 모션 트래킹",
    page2_sub: "불필요한 장비에 얽매이지 말고 카메라만 켜세요!",

    page3_title: "3D 세상을 경험하세요",
    page3_line1:
      "단 한 장의 사진으로 아바타를 생성하거나",
    page3_line2:
      "처음부터 직접 만들어보세요",
    page3_line3:
      "",
    page3_line4:
      "방송을 도울 AI NPC와 AI 아바타 친구를 만들어보세요",

    page4_title: "다양한 액세서리와 무대를 고르세요",

    bottom_cta_label: "지금 후원하기",
  },
};

function useLangCopy() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").toLowerCase().startsWith("ko")
    ? "ko"
    : "en";
  return useMemo(() => copy[lang as "ko" | "en"], [lang]);
}

const Tih: FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const c = useLangCopy();
  const langClass = i18n.language?.toLowerCase().startsWith("ko")
    ? styles.langKo
    : styles.langEn;

  return (
    <main className={`${styles.tih} ${langClass}`}>

      {/* Page 1 */}
      <section
        className={`${styles.block} ${styles.blockHero}`}
        style={{ backgroundImage: `url(${IMG_BG_01})` }}
        aria-label="Hero"
      >
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>{c.page1_title} <br/> {c.page1_title_2} </h1>
          {/* <img 
            className={`${styles.kickstarterLogo}`}
            src={IMG_KICK_LOGO} alt="" 
          /> */}
          <br/>
          {/* <a
            className={`${styles.cta} ${styles.ctaKick}`}
            href="https://www.kickstarter.com/projects/vdigm/tih-a-next-gen-3d-ai-avatars-and-motion-tracking-service?term=vdigm&total_hits=1&category_id=35"
            target="_blank"
            rel="noreferrer"
          >
            {c.cta_back_now}
          </a> */}
        </div>
      </section>

      {/* Page 2 */}
      <section
        className={`${styles.block} ${styles.blockBg}`}
        style={{ backgroundImage: `url(${IMG_BG_02})` }}
        aria-label="Motion Tracking"
      >
        <div className={styles.container}>
          <h2 className={styles.blockTitle}>{c.page2_title}</h2>
          <p className={styles.blockSub}>{c.page2_sub}</p>
        </div>
      </section>

      {/* Page 3 */}
      <section
        className={`${styles.block} ${styles.blockBg}`}
        style={{ backgroundImage: `url(${IMG_BG_03})` }}
        aria-label="Experience Your 3D World"
      >
        <div className={styles.containerRight}>
          <h2 className={styles.blockTitle}>{c.page3_title}</h2>

          <div className={styles.blockList}>
            {c.page3_line1}
            <br/>
            {c.page3_line2}
            <br/>
            {c.page3_line3}
            <br/>
            {c.page3_line4}
            <p></p>
            <p></p>
          </div>
        </div>
      </section>

      {/* Page 4 */}
      <section
        className={`${styles.block} ${styles.blockBg}`}
        style={{ backgroundImage: `url(${IMG_BG_04})` }}
        aria-label="Accessories & Stages"
      >
        <div className={styles.container}>
          <h2 className={styles.blockTitle}>{c.page4_title}</h2>
        </div>
      </section>

      {/* Page 5 */}
      {/* <section
        className={`${styles.block} ${styles.blockBottom}`}
        style={{ backgroundImage: `url(${IMG_BG_05})` }}
        aria-label="Bottom CTA"
      >
        <div className={styles.bottomCard}>
            
          <img 
            className={`${styles.kickstarterLogo}`}
            src={IMG_KICK_LOGO} alt="" 
          />
          <br/>
          <a
            className={`${styles.cta} ${styles.ctaKick}`}
            href="https://www.kickstarter.com/projects/vdigm/tih-a-next-gen-3d-ai-avatars-and-motion-tracking-service?term=vdigm&total_hits=1&category_id=35"
            target="_blank"
            rel="noreferrer"
          >
            {c.bottom_cta_label}
          </a>
        </div>
      </section> */}


      <section>
        <nav className={`${styles.socialBar}`} aria-label="Social links">
            {Logo_IMG.map(({ name, href }) => (
                <a key={name} href={href} target="_blank" title={name}>
                <img
                    src={`/assets/logo_sns_${name}.png`}
                    alt={`${name} logo`}
                    loading="lazy"
                    decoding="async"
                />
                </a>
            ))}
        </nav>

      </section>
    </main>
  );
};

export default Tih;
